import { FormControl, Grid, IconButton, InputLabel, Select, TextField, Divider
    , Typography, Stack, Box, Popover, List, ListItemButton, ListItemText } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListEstadosAsistencia, setListModalidades, setListTiposSesion, setListPuntuacionesCriterio
    , setListPuntuacionesActividad, setNombreTerapeuta } from "../redux/sessionSlice";
import { FormHelperText as HelperText } from '@mui/material';
import FeeSearch from './InvoiceItemSearch';

// Dia de la semana con la numeracion de la base: 1 = Lunes ... 7 = Domingo.
// El getDay() de JavaScript usa 0 = Domingo ... 6 = Sabado, que solo
// coincide de lunes a sabado: el domingo daria 0 y la base espera 7.
const diaDeLaSemana = (fecha) => (fecha.getDay() === 0 ? 7 : fecha.getDay());

const HORAS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTOS = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

const mostrarHora = (valor) => {
    if (!valor) return "";
    const partes = String(valor).split(":");
    if (partes.length < 2) return String(valor);
    return partes[0].padStart(2, "0") + ":" + partes[1].padStart(2, "0").slice(0, 2);
};

// Campo de hora nativo: edicion por teclado, spinners y selector del navegador.
const CampoHora = ({ label, value, onChange, disabled, error, helperText, required }) => {
    const visible = mostrarHora(value);

    return (
        <TextField
            required={required}
            label={label}
            type="time"
            value={visible}
            onChange={(evento) => {
                if (disabled) return;
                onChange(evento.target.value);
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{ step: 300 }} // 5 min
            disabled={disabled}
            size="small"
            fullWidth
            error={error}
            helperText={helperText}
        />
    );
};

const Session = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.session.entity);
    const defaultEntity = useSelector((state) => state.session.defaultEntity);
    const nombreTerapeuta = useSelector((state) => state.session.nombreTerapeuta);
    const listEstadosAsistencia = useSelector((state) => state.session.listEstadosAsistencia);
    const listModalidades = useSelector((state) => state.session.listModalidades);
    const listTiposSesion = useSelector((state) => state.session.listTiposSesion);
    const listPuntuacionesCriterio= useSelector((state) => state.session.listPuntuacionesCriterio);
    const listPuntuacionesActividad= useSelector((state) => state.session.listPuntuacionesActividad);
    const validate = useSelector((state) => state.session.validationActive);
    const dispatch = useDispatch();
    // const [openFeeSearch, setOpenFeeSearch] = useState(false);
    const fechaHoy = new Date();
    const fechaIngresoMinimo = new Date(2010, 1, 1);

    var validation = {
        fecha: {
            error: Date.parse(entity.fecha) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
        horaInicio: {
            error: entity.horaInicio.length < 1,
            message: "Falta ingresar la hora de inicio",
        },
        idEstadoAsistencia: {
            error: entity.idEstadoAsistencia == null || entity.idEstadoAsistencia == 0,
            message: "Falta ingresar el estado de asistencia",
        },
    }
    // const openCloseFeeSearch = () => { setOpenFeeSearch(!openFeeSearch); }

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Sesion/GetSesionView?idSesion=" + params.id)
            .then((response) => {
                if (response.data.data == null || response.data.data.length == 0){
                    dispatch(setEntity(defaultEntity));
                    dispatch(setData({name: "idTerapiaPeriodo", value: params.idTerapiaPeriodo}))
                }
                else {
                    dispatch(setEntity(response.data.data));
                }

                api.get("/Terapia/GetTerapiaPeriodoResumenView?idTerapiaPeriodo=" + params.idTerapiaPeriodo)
                .then((res) => {
                    if (res.data.data != null){
                        dispatch(setData({name: "idTerapia", value: res.data.data.idTerapia}))
                        // Periodo de la sesion: con el y la terapia se arma el
                        // filtro del Plan de Terapia que se muestra mas abajo
                        // (el plan cuyas fechas coinciden con las del periodo).
                        dispatch(setData({name: "idPeriodo", value: res.data.data.idPeriodo}))
                        dispatch(setData({name: "codigoPeriodo", value: res.data.data.codigoPeriodo}))
                        dispatch(setData({name: "participante", value: res.data.data.participante}))
                        dispatch(setNombreTerapeuta(res.data.data.terapeuta))

                        // Hora de inicio: el primer horario de la terapia del dia
                        // de la semana actual. El horario viene como "HH:mm",
                        // que es lo que espera el input de hora.
                        api.get("/Terapia/GetsTerapiaHorarioViewByWeekDay?idTerapia="
                            + res.data.data.idTerapia
                            + "&weekDay=" + diaDeLaSemana(fechaHoy))
                        .then((resSchedule) => {
                            if (resSchedule.data?.data != null && resSchedule.data.data.length > 0){
                                dispatch(setData({name: "horaInicio", value: resSchedule.data.data[0].horaInicio}))
                            }
                        })
                        .catch((err) => {
                            console.log("Err: ", err);
                        });
                    }
                })
                .catch((err) => {
                    console.log("Err: ", err);
                });
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }, [])
    const fetchListEstadosAsistencia = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=58")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstadosAsistencia(response?.data?.data || []));
    }, [])
    const fetchListModalidades = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=80")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListModalidades(response?.data?.data || []));
    }, [])

    // Los tipos de sesion (catalogo 323): "Regular" es el de siempre y
    // "Reporte trimestral" es la sesion que resume el trimestre.
    const fetchListTiposSesion = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=323")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListTiposSesion(response?.data?.data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListEstadosAsistencia();
        fetchListModalidades();
    fetchListTiposSesion();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    return (
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(entity)} */}
            <Grid item xs={12}>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <TextField
                        disabled
                        name="codigoPeriodo"
                        label="Periodo"
                        fullWidth
                        value={entity.codigoPeriodo}
                        size="small"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        disabled
                        name="participante"
                        label="Participante"
                        fullWidth
                        value={entity.participante}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="fecha"
                        label="Fecha"
                        fullWidth
                        type="date"
                        value={moment(entity.fecha).format('yyyy-MM-DD')}
                        onChange={setDataEntity}
                        error={validate.fecha && validation.fecha.error}
                        helperText={validate.fecha && validation.fecha.error ? validation.fecha.message : ""}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <CampoHora
                        required
                        label="Hora Inicio"
                        value={entity.horaInicio}
                        onChange={(valor) => {
                            dispatch(setData({name: "horaInicio", value: valor}));
                        }}
                        disabled={isReadOnly}
                        error={validate.horaInicio && validation.horaInicio.error}
                        helperText={validate.horaInicio && validation.horaInicio.error ? validation.horaInicio.message : ""}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idEstadoAsistencia && validation.idEstadoAsistencia.error}>
                        <InputLabel htmlFor="input-estadoasistencia">Asistencia</InputLabel>
                        <Select
                            native
                            label="Asistencia"
                            value={entity.idEstadoAsistencia}
                            onChange={(event, newValue) => {
                                var id = event.nativeEvent.target.selectedIndex;

                                dispatch(setData({name: "idEstadoAsistencia", value: event.target.value}))
                                dispatch(setData({name: "estadoAsistencia", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idEstadoAsistencia',
                                id: 'input-estadoasistencia',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstadosAsistencia.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idEstadoAsistencia && validation.idEstadoAsistencia.error ? validation.idEstadoAsistencia.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-modalidad">Modalidad</InputLabel>
                        <Select
                            native
                            label="Modalidad"
                            value={entity.idModalidad}
                            fullWidth
                            onChange={(event, newValue) => {
                                var id = event.nativeEvent.target.selectedIndex;

                                dispatch(setData({name: "idModalidad", value: event.target.value}))
                                dispatch(setData({name: "modalidad", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idModalidad',
                                id: 'input-modalidad',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listModalidades.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>
                            {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                        </HelperText>
                        <HelperText>
                            {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                        </HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-tiposesion">Tipo de sesion</InputLabel>
                        <Select
                            native
                            label="Tipo de sesion"
                            value={entity.idTipoSesion || 324}
                            fullWidth
                            onChange={(event) => {
                                const id = parseInt(event.target.value) || 324;
                                const elegida = listTiposSesion.find((row) => row.id === id);

                                dispatch(setData({name: "idTipoSesion", value: id}))
                                dispatch(setData({name: "tipoSesion", value: elegida ? elegida.descripcion : "Regular"}))
                            }}
                            inputProps={{
                                name: 'idTipoSesion',
                                id: 'input-tiposesion',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTiposSesion.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        name="observaciones"
                        label="Observaciones"
                        fullWidth
                        value={entity.observaciones}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
            </Grid>
            </Grid>
        </Grid>
    );
}
export default Session;
